<template>
  <div class="questionnaire-question-content">

    <ModalText
        v-if="isModalTextVisible"
        :statement=statement
        :title=title
        @close="closeModalText"
    />

    <div v-if="this.ifFirstPage">
      <div class="questionnaire-question-text-consigne">
        Lisez cet extrait* d'article de magazine répondez aux questions suivantes...
      </div>

      <div id="questionSentenceText" class="questionnaire-question-text" v-html="this.statement"/>

      <div class="questionnaire-question-text-extrait">
        *{{ this.title }}
      </div>
    </div>

    <div v-else>
      <div class="questionnaire-question-question">
        Voir le texte
      </div>

      <div class="questionnaire-question-question">
        <div class="questionnaire-question-image" @click="showModalText">
          <img src="@/assets/img/eye.png">
        </div>
      </div>

      <div class="questionnaire-question-question">
        {{ this.question }}
      </div>

      <div v-for="proposition of propositions" :key="proposition.label">
        <div v-if="this.answer != undefined && this.answer.includes(proposition)" :value=proposition class="col-md-8 questionnaire-question-proposition-selected" tabindex="0" v-on:click="focus">
          <div class="questionnaire-question-proposition-choix">
            {{ proposition }}
          </div>
        </div>
        <div v-else :value=proposition class="col-md-8 questionnaire-question-proposition" tabindex="0" v-on:click="focus">
          <div class="questionnaire-question-proposition-choix">
            {{ proposition }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalText from '@/components/Modal/Questionnaire/Text.vue';
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "ExpressionQuestionMultipleCheckboxWithText",
  components: {
    ModalText
  },
  props: {
    question: String,
    statement: String,
    previousStatement: String,
    propositions: Array,
    title: String
  },
  data() {
    var bIfFirstPage = false
    if (this.$parent.idQuestion == '2000' || this.$parent.idQuestion == '2004') {
      bIfFirstPage = true
    }

    return {
      ifFirstPage: bIfFirstPage,
      answer: null,
      isModalTextVisible: false
    }
  },
  methods: {
    focus: function (event) {
      event.currentTarget.classList.toggle("questionnaire-question-proposition-selected");
      var answersTmp = [];
      var elements = document.getElementsByClassName('questionnaire-question-proposition-selected')
      Array.prototype.forEach.call(elements, function (el) {
        answersTmp.push(el.getAttribute('value'));
      });
      this.answer = answersTmp
    },
    close: function () {
      this.$emit('close');
    },
    showModalText: function () {
      this.isModalTextVisible = true;
    },
    closeModalText: function () {
      this.isModalTextVisible = false;
    }
  },
  mounted() {
    var domainId = this.$parent.domainId
    var indexQuestion = this.$parent.indexQuestion

    UserService.getUserTestQuestions(domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
